export * from './id';
export * from './color-sets';
export * from './sort';
export * from './throttle';
export * from './color-utils';
export * from './visibility-observer';
export * from './types';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@swimlane/ngx-charts/release/utils/index.js
// module id = ../../../../@swimlane/ngx-charts/release/utils/index.js
// module chunks = 4